import React from 'react';
import * as styles from './Footer.module.scss';
import { Link } from 'gatsby';
import clsx from 'clsx';
import logomark from '../../images/logomark.svg';

export default function Footer({copyright, links = []}) {
  let internal = [];
  let social = [];

  links.forEach((link)=> {
    if(link.type === 'social') {
      social.push(link);
    } else {
      internal.push(link);
    }
  });

  return (
    <footer className={clsx('section-wrapper')}>
      <div className={styles.wrapper}>
        <section className={styles.content}>
          <div className={styles.logo}><img src={logomark} alt="Logo mark"/></div>
          <div className={styles.copyright}>{copyright}</div>
        </section>
        <section className={styles.links}>
          <div>
            { internal.map(link => <Link key={link.text} to={link.url}>{link.text}</Link>) }
          </div>
          <div className={styles.social}>
            { social.map(link => <Link key={link.text} to={link.url}><img src={link.img} alt={link.text} /></Link>) }
          </div>
        </section>
      </div>
    </footer>
  );
}